import React from 'react';
import cx from 'classnames';

export type CitationPillProps = {
  displayNumber: number;
  isAdjacent: boolean;
  onClick: () => void;
};

export const CitationPill = ({ displayNumber, isAdjacent, onClick }: CitationPillProps): JSX.Element => (
  <button
    type="button"
    className={cx('c-els-pill', 'c-els-pill--citation', {
      'c-els-pill--citation-adjacent': isAdjacent
    })}
    aria-label={`Go to citation ${displayNumber}`}
    onClick={onClick}
  >
    {displayNumber}
  </button>
);

export default CitationPill;
